<template>
  <div class="custom">
    <!-- <h2>个性定制化开发</h2> -->
    <!-- <p></p> -->
    <div class="custom-list">
      <div
        class="item"
        v-for="item in customList"
        :key="item.id"
        @click="pageUrl(item.url)"
      >
        <img :src="item.acitveImg" />
        <!-- <img v-else :src="item.img" /> -->
        <div class="desc">
          {{ item.title }}
        </div>
        <div class="desc">
          {{ item.desc }}
        </div>
      </div>
    </div>
      <img src="../../static/images/7mouth/xuhao@2x.png" class="line-box" alt='图片'/>
    <div class="custom-list">
      <div
        class="item"
        v-for="item in endList"
        :key="item.id"
        @click="pageUrl(item.url)"
      >
        <div class="desc">
          {{ item.title }}
        </div>
        <div class="desc">
          {{ item.desc }}
        </div>
        <img :src="item.acitveImg" />
        <!-- <img v-else :src="item.img" /> -->
      </div>
    </div>
    <h2>为什么选择我们？</h2>
    <h5>“1+10”核心产品服务体系</h5>
      <img src="../../static/images/7mouth/process@2x.png" class="why-choose-this" alt='图片'/>

      <div class="list-box" v-for="(item,index) in chooseList" :key="index">
        <div class="list-img-box">
          <img :src="item.acitveImg" alt='图片'/>
        </div>
        <div class="list-cont">
          <h5>{{item.title}}</h5>
          <p>{{item.desc}}</p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      enterIndex: -1,
      customList: [
        {
          id: 0,
          img: require("../../static/images/custom/wulianwanghei.png"),
          acitveImg: require("../../static/images/7mouth/rongzicelue.png"),
          url: "/",
          title:'定制',
          desc: "融资策略",
        },
        {
          id: 1,
          img: require("../../static/images/custom/apphei.png"),
          acitveImg: require("../../static/images/7mouth/duijiejigou.png"),
          url: "/",
          title:'对接',
          desc: "一流投资机构",
        },
        {
          id: 2,
          img: require("../../static/images/custom/qiyehei.png"),
          acitveImg: require("../../static/images/7mouth/chanyefuwu.png"),
          url: "/",
          title:'深挖',
          desc: "产业服务",
        },
      ],
      endList:[
        {
          id: 3,
          img: require("../../static/images/custom/gongzhonghaohei.png"),
          acitveImg: require("../../static/images/7mouth/sahngyejiegou.png"),
          url: "/",
          title:'梳理',
          desc: "商业结构",
        },
        {
          id: 4,
          img: require("../../static/images/custom/xiaocchengxuhei.png"),
          acitveImg: require("../../static/images/7mouth/chanyeziyuan.png"),
          url: "/",
          title:'提供',
          desc: "产业资源",
        }
      ],
        chooseList:[
          {
            acitveImg: require("../../static/images/7mouth/jishuzhuli.png"),
            title:'技术助力',
            desc: "建立先进的研发管理流程及严格的质量控制体系，实现技术助力",
          },
          {
            acitveImg: require("../../static/images/7mouth/chanpinfuneng.png"),
            title:'产品赋能',
            desc: "提供“1+10”核心产品服务体系，实现产品赋能",
          },
          {
            acitveImg: require("../../static/images/7mouth/shangyechenggong.png"),
            title:'商业成功',
            desc: "洞察商业模式的核心价值与风险，实现商业成功",
          }
        ]
    };
  },
  methods: {
    mouseEnter(index) {
      this.enterIndex = index;
    },
    mouseLeave() {
      this.enterIndex = -1;
    },
    pageUrl(url) {
      this.$router.push(url);
    },
  },
};
</script>
<style lang="stylus" scoped>
.custom {
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  padding: 0 0 0.22rem;
  // margin-top: 48px;

  h2 {
    text-align: center;
    margin-bottom: 0.48rem;
    font-size: 0.38rem;
    font-weight: 800;
    color: #333333;
    line-height: 0.28rem;
  }

  .custom-list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-items: center;

    .item {
      width: 33%;
      text-align: center;
      margin-bottom: 0.4rem;
    }

    img {
      width:1.8rem;
      height: 1.4rem;
      margin :12px 0;
    }

    .active {
      color: #FFC000;
    }

    .desc {
      padding-top: 0.24rem;
      font-size: 0.28rem;
      font-weight: 400;
      color: #333333;
      line-height: 0.28rem;
    }
  }
  h5{
    text-align :center;
    font-size: 0.3rem;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    line-height: 0.28rem;
    margin :0 0 0.21rem 0;
  }
  .why-choose-this{
    padding :0 0.24rem;
    margin-bottom :0.18rem;
  }
}
.list-box{
  width :94%;
  background: #FFFFFF;
  border: 1px solid #E1E6F0;
  margin :0.2rem auto;
  padding:0.27rem 0.28rem 0.31rem;
  display :flex;
  justify-content :flex-start;
  img{
    width :0.6rem;
    height :0.6rem;
    display:block
  }

  h5{
    font-size: 0.28rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 0.28rem;
    text-align :left;
  }
}
.list-img-box{
    width :0.6rem;
    height :0.6rem;
    display :block;
    margin :0 0.32rem 0 0;
}
.list-cont{
  p{
    font-size: 0.24rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 0.36rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeCustom.vue